/* Canvas Mérida · Buscador instantáneo (ver snippets/cm-search.liquid) */
(function () {
'use strict';
var root = document.getElementById('cm-sx');
if (!root || root.dataset.ready) return;
root.dataset.ready = '1';
if (root.parentNode !== document.body) document.body.appendChild(root);
var input = root.querySelector('#cm-sx-q');
var form = root.querySelector('.cm-sx__bar');
var intro = root.querySelector('[data-sx-intro]');
var dyn = root.querySelector('[data-sx-dyn]');
var body = root.querySelector('.cm-sx__body');
var clearBtn = root.querySelector('[data-sx-clear]');
var recentBox = root.querySelector('[data-sx-recent]');
var recentList = root.querySelector('[data-sx-recent-list]');
var bestBox = root.querySelector('[data-sx-best]');
var html = document.documentElement;
var TRIGGERS = '#form-minisearch input[name="q"], .cm-mmd__search input[name="q"], [data-cm-sx-open], [data-minisearch-trigger], .sticky-search';
var KEY = 'cmSxRecent';
var cache = {};
var ctl = null, timer = null, active = -1, bestLoaded = false, scrollY = 0;
/* ---------- utilidades ---------- */
function norm(s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function searchUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
function suggestUrl(q) {
return '/search/suggest?q=' + encodeURIComponent(q) +
'&resources%5Btype%5D=product,collection,query&resources%5Blimit%5D=8&resources%5Blimit_scope%5D=each' +
'&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=cm-search-suggest';
}
function extract(text) {
var d = new DOMParser().parseFromString(text, 'text/html').querySelector('.cm-sx__res');
return d ? d.outerHTML : '';
}
/* ---------- recientes ---------- */
function getRecent() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
function setRecent(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
function saveRecent(q) {
q = (q || '').trim(); if (q.length < 2) return;
var a = getRecent().filter(function (x) { return norm(x) !== norm(q); });
a.unshift(q); setRecent(a.slice(0, 6));
}
function renderRecent() {
var a = getRecent();
recentBox.hidden = !a.length;
recentList.innerHTML = a.map(function (q) {
return '<a class="cm-sx__chip cm-sx__chip--recent" data-sx-item data-sx-q="' + esc(q) + '" href="' + searchUrl(q) + '">' +
'<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 7.5V12l3 2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' + esc(q) + '</a>';
}).join('');
}
/* ---------- resaltado sin acentos ---------- */
function highlight(q) {
var terms = norm(q).split(/\s+/).filter(function (t) { return t.length > 1; });
if (!terms.length) return;
dyn.querySelectorAll('.cm-sx__pt').forEach(function (el) {
var src = el.textContent, n = '', map = [];
for (var i = 0; i < src.length; i++) {
var c = norm(src[i]);
for (var k = 0; k < c.length; k++) { n += c[k]; map.push(i); }
}
var marks = new Array(src.length).fill(false);
terms.forEach(function (t) {
var re = new RegExp('(^|[^a-z0-9ñ])(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'g'), m;
while ((m = re.exec(n))) {
var s = m.index + m[1].length;
for (var j = s; j < s + m[2].length; j++) marks[map[j]] = true;
}
});
if (marks.indexOf(true) < 0) return;
var out = '', open = false;
for (var x = 0; x < src.length; x++) {
if (marks[x] && !open) { out += '<mark>'; open = true; }
if (!marks[x] && open) { out += '</mark>'; open = false; }
out += esc(src[x]);
}
if (open) out += '</mark>';
el.innerHTML = out;
});
}
/* ---------- abrir / cerrar ---------- */
function isOpen() { return !root.hidden; }
function open(prefill) {
// si el menú móvil está abierto, se cierra para que el buscador quede al frente
var mmd = document.querySelector(".cm-mmd.is-open .cm-mmd__x"); if (mmd) mmd.click();
if (isOpen()) { input.focus(); return; }
scrollY = window.scrollY;
root.hidden = false;
html.classList.add('cm-sx-open');
if (typeof prefill === 'string' && prefill.trim()) input.value = prefill;
input.focus({ preventScroll: true });
try { input.setSelectionRange(input.value.length, input.value.length); } catch (e) {}
renderRecent();
loadBest();
update(true);
unhide();
setTimeout(function () { unhide(); if (isOpen() && document.activeElement !== input) input.focus({ preventScroll: true }); }, 80);
document.dispatchEvent(new CustomEvent('cm-sx:open'));
}
function close() {
if (!isOpen()) return;
root.hidden = true;
html.classList.remove('cm-sx-open');
input.blur();
if (Math.abs(window.scrollY - scrollY) > 2) window.scrollTo(0, scrollY);
}
/* ---------- lo más vendido (estado inicial) ---------- */
function loadBest() {
if (bestLoaded) return; bestLoaded = true;
fetch('/?section_id=cm-search-suggest').then(function (r) { return r.text(); }).then(function (t) {
bestBox.innerHTML = extract(t);
}).catch(function () { bestLoaded = false; });
}
/* ---------- búsqueda en vivo ---------- */
function setActive(i) {
var items = visibleItems();
items.forEach(function (el) { el.classList.remove('is-active'); el.removeAttribute('aria-selected'); });
active = i;
if (i >= 0 && items[i]) {
items[i].classList.add('is-active'); items[i].setAttribute('aria-selected', 'true');
items[i].scrollIntoView({ block: 'nearest' });
}
}
function visibleItems() {
var scope = root.classList.contains('has-q') ? dyn : intro;
return Array.prototype.slice.call(scope.querySelectorAll('[data-sx-item]'));
}
function show(q, h) {
if (input.value.trim() !== q) return;
dyn.innerHTML = h;
highlight(q);
setActive(-1);
body.scrollTop = 0;
}
function update(immediate) {
var q = input.value.trim();
clearBtn.hidden = !q;
root.classList.toggle('has-q', !!q);
intro.hidden = !!q;
clearTimeout(timer);
if (!q) { dyn.innerHTML = ''; root.classList.remove('is-loading'); setActive(-1); return; }
if (cache[q] != null) { root.classList.remove('is-loading'); show(q, cache[q]); return; }
root.classList.add('is-loading');
timer = setTimeout(function () {
if (ctl) ctl.abort();
ctl = 'AbortController' in window ? new AbortController() : null;
fetch(suggestUrl(q), ctl ? { signal: ctl.signal } : {})
.then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
.then(function (t) {
cache[q] = extract(t);
if (input.value.trim() === q) root.classList.remove('is-loading');
show(q, cache[q]);
})
.catch(function (e) {
if (e && e.name === 'AbortError') return;
root.classList.remove('is-loading');
if (input.value.trim() === q) dyn.innerHTML = '<div class="cm-sx__res"><p class="cm-sx__none-p">No pudimos cargar sugerencias. Presiona Enter para ver los resultados.</p></div>';
});
}, immediate ? 0 : 150);
}
function go(q) {
q = (q || '').trim(); if (!q) { input.focus(); return; }
saveRecent(q);
try { if (window.gtag) gtag('event', 'search', { search_term: q }); } catch (e) {}
try { if (window.fbq) fbq('track', 'Search', { search_string: q }); } catch (e) {}
window.location.href = searchUrl(q);
}
/* ---------- eventos del buscador ---------- */
input.addEventListener('input', function () { update(false); });
form.addEventListener('submit', function (e) {
e.preventDefault(); e.stopImmediatePropagation();
var items = visibleItems();
if (active >= 0 && items[active]) { items[active].click(); return; }
go(input.value);
}, true);
input.addEventListener('keydown', function (e) {
var items = visibleItems(), n = items.length;
if (e.key === 'ArrowDown') { e.preventDefault(); if (n) setActive(active + 1 >= n ? 0 : active + 1); }
else if (e.key === 'ArrowUp') { e.preventDefault(); if (n) setActive(active - 1 < 0 ? n - 1 : active - 1); }
else if (e.key === 'Escape') { e.preventDefault(); if (input.value) { input.value = ''; update(true); } else close(); }
});
root.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && e.target !== input) { e.preventDefault(); close(); }
if (e.key === 'Tab') {
var f = Array.prototype.slice.call(root.querySelectorAll('input, button:not([hidden]), a[href]')).filter(function (el) { return el.offsetParent !== null; });
if (!f.length) return;
if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
}
});
clearBtn.addEventListener('click', function () { input.value = ''; update(true); input.focus(); });
root.addEventListener('click', function (e) {
var t = e.target;
if (t.closest('[data-sx-close]')) { e.preventDefault(); close(); return; }
if (t.closest('[data-sx-recent-clear]')) { setRecent([]); renderRecent(); input.focus(); return; }
var chip = t.closest('[data-sx-q]');
if (chip && !e.metaKey && !e.ctrlKey) {
e.preventDefault();
if (root.classList.contains('has-q') || chip.closest('[data-sx-recent-list]')) { go(chip.getAttribute('data-sx-q')); return; }
input.value = chip.getAttribute('data-sx-q'); update(true); input.focus(); return;
}
var link = t.closest('a[href]');
if (link && link.hasAttribute('data-sx-all')) { e.preventDefault(); go(input.value); return; }
if (link && root.classList.contains('has-q')) saveRecent(input.value);
});
/* ---------- disparadores en el sitio ---------- */
function bindTrigger(el) {
if (el.dataset.cmSx) return; el.dataset.cmSx = '1';
if (el.tagName === 'INPUT') el.setAttribute('readonly', '');
el.setAttribute('aria-haspopup', 'dialog');
el.setAttribute('aria-controls', 'cm-sx');
var f = el.form;
if (f && !f.dataset.cmSx) {
f.dataset.cmSx = '1';
f.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); open(el.value); }, true);
var b = f.querySelector('button[type="submit"], button:not([type])');
if (b) b.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); open(el.value); }, true);
}
}
function bindAll() { document.querySelectorAll(TRIGGERS).forEach(bindTrigger); }
bindAll();
document.addEventListener('DOMContentLoaded', bindAll);
/* Interceptamos en window (fase de captura) para que ninguna otra app de búsqueda reaccione al toque */
function trig(e) { var el = e.target && e.target.closest && e.target.closest(TRIGGERS); return el && !root.contains(el) ? el : null; }
['pointerdown', 'mousedown', 'touchstart', 'touchend', 'focus', 'focusin'].forEach(function (type) {
window.addEventListener(type, function (e) {
var el = trig(e); if (!el) return;
e.stopImmediatePropagation();
if (type === 'focus' || type === 'focusin') { bindTrigger(el); el.blur(); open(el.value); }
}, { capture: true, passive: type.indexOf('touch') === 0 });
});
window.addEventListener('click', function (e) {
var el = trig(e); if (!el) return;
e.preventDefault(); e.stopImmediatePropagation(); bindTrigger(el); open(el.value);
}, true);
/* Si otra app oculta la página (Rapid Search en móvil), la volvemos a mostrar */
function unhide() {
var hidden = document.querySelectorAll('.rps_body_child_visibility');
for (var k = 0; k < hidden.length; k++) hidden[k].classList.remove('rps_body_child_visibility');
html.classList.remove('rps-app-active');
}
if ('MutationObserver' in window) {
new MutationObserver(function (ms) {
for (var k = 0; k < ms.length; k++) { if (ms[k].target.classList && ms[k].target.classList.contains('rps_body_child_visibility')) { unhide(); break; } }
}).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
}
document.addEventListener('keydown', function (e) {
if (isOpen()) return;
var tag = (e.target.tagName || '').toLowerCase();
var typing = tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable;
if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); open(); }
else if (e.key === '/' && !typing) { e.preventDefault(); open(); }
});
window.cmSearch = { open: open, close: close };
})();